/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronCompactDown = createReactComponent(
  "chevron-compact-down",
  "IconChevronCompactDown",
  [["path", { d: "M4 11l8 3l8 -3", key: "svg-0" }]]
);

export { IconChevronCompactDown as default };
//# sourceMappingURL=IconChevronCompactDown.js.map
